<template>
  <form
      novalidate
      class="w-100"
      @submit.prevent="submit">
    <div class="d-flex p-y-1 flex-1-1:mo">
      <div
          :class="{ 'input-message error': showError && errorMessage }"
          :error="errorMessage"
          class="input-container"
          selenium="input-container">
        <input
            v-vk-input
            v-vk-focus
            v-model="zipcode"
            type="tel"
            name="postal"
            autocomplete="postal-code"
            class="input"
            selenium="zip-code-modal-input">
        <label class="input-label" selenium="zip-code-label">Enter your zipcode</label>
      </div>
      <button class="btn m-l-1" selenium="zip-code-modal-button">
        OK
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'location-form',
  data () {
    return {
      showError: false,
      locationApiError: false,
    };
  },
  computed: {
    zipcode: {
      get () {
        return this.$store.state.homepage.geo.zipcode;
      },
      set (value) {
        this.$store.commit('homepage/geo/updateZipcode', value);
        this.preventSubmission = false;
      },
    },
    invalidZipcode () {
      return !/^\d{5}$/.test(this.zipcode);
    },

    errorMessage () {
      if (this.invalidZipcode || this.locationApiError) {
        return 'Please enter a valid zipcode.';
      }
      return '';
    },
  },
  watch: {
    zipcode () {
      if (this.invalidZipcode || this.locationApiError) {
        this.showError = false;
      }
    },
  },
  methods: {
    submit () {
      this.preventSubmission = true;
      this.showError = this.invalidZipcode;
      this.getLocation();
    },
    async getLocation () {
      try {
        const response = await this.$store.dispatch('homepage/geo/getLocationByZipcode', {
          zipcode: this.zipcode,
        });
        if (response.total !== 0) {
          this.locationApiError = false;
        } else {
          throw new Error('Invalid zipcode or zipcode doesn\'t exist');
        }
      } catch (error) {
        this.locationApiError = true;
        this.showError = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .FORM {
    height: 64px;
  }
  .LOCATION-MODAL {
    @include mobile-only() {
      height: auto;
    }
  }
  .ERROR-MESSAGE {
    background-color: $color-red;
    @include margin-bottom(1);
    @include margin-x(1);
    @include padding(2);
    text-align: center;
    color: white;
    @include tablet() {
      position: absolute;
      margin-top: -$unit;
      margin-left: 0;
    }
  }
  .SELECT-CITY {
    height: 24px;
  }
</style>
